import { getTheme, mergeStyleSets } from "@fluentui/react";

const theme = getTheme();

export const useStyles = () => {
	return mergeStyleSets({
		card: {
			padding: "20px 25px 25px 25px",
			boxShadow: theme.effects.elevation8,
			backgroundColor: "white",
		},
		cardMain: {
			boxShadow: theme.effects.elevation8,
			backgroundColor: "white",
			minHeight: "250px",
		},
		cardMainHeading: {
			padding: "20px 20px 20px 20px",
			height: "10%",
			borderBottomStyle: "solid",
			borderBottomWidth: "1px",
			borderBottomColor: "#cec9c9",
		},
		cardContent: {
			padding: "30px 30px 30px 30px",
			minHeight: "90%",
		},
		smallCard: {
			width: "180px",
			minHeight: "100%",
		},
		count: {
			marginLeft: "32px",
		},
	});
};
